<template>
  <div>
    <WebHeaderView />
    <HomeSwipeView :lst="imgLst" />
    <HotShopsView />
    <HomeProductView />
  </div>
</template>

<script>
import { HomeSwipeView,HomeProductView,HotShopsView } from './components/index'
import WebHeaderView from '@/components/header/index.vue'
export default {
  name: 'HomeView',
  components: { HomeSwipeView,WebHeaderView,HomeProductView,HotShopsView },
  data(){
    return {
      imgLst:[
        //{img:require('@/assets/img/tmp/1.png')},
        //{img:require('@/assets/img/tmp/2.png')},
      ],
     
    }
  },
  mounted(){
    this.getBanner()
  },
  methods:{
    async getBanner(){
      await this.$http({
        method: 'post',
        url: 'homeBanner'
      }).then(res => {
        this.imgLst = res.data.list
      })
    }
  }
}
</script>

<style>

</style>
